require('./plans-widget-template.html');

angular.module('bbl.module.plans-billings')
.directive('plansWidget', ['$sce', function($sce) {
	return {
		restrict: 'EA',
		templateUrl: 'plans-widget-template.html',
		scope: {
			currentPlan: '=',
      selectedPlan: '=',
			plans: '=',
			onUpdate: '&',
			onCancel: '&',
		},
		link: function($scope, $el) {
      var currentPlan = $scope.currentPlan || {};
      $scope.c = {planType: currentPlan.number_type || 'local'};

      $scope.getPlans = function(type, unlimited) {
        unlimited = unlimited !== undefined ? unlimited : false;

        return $scope.plans.filter(function(p) {
          return p.display_order !== null && p.number_type === type && p.unlimited === unlimited;
        }).slice(0, 4);
      };

      $scope.parsePlanTitle = function(title) {
        return $sce.trustAsHtml(title.replace(/toll\-free/i, '<span class="nw">$&</span>'));
      };
		}
	};
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/plans-billings/plans-widget/index.js
 ** module id = 371
 ** module chunks = 0
 **/